import type { ReactNode } from 'react'

import type { Paths } from '@fourthwall/types/dist/string'

import type { DashboardPermissions } from './types'
import { useDashboardPermissions } from './useDashboardPermissions'

type Props = {
  permission: Paths<DashboardPermissions> | Paths<DashboardPermissions>[]
  children: ReactNode
}
export const DashboardPermissionGuard = ({ permission, children }: Props) => {
  const { hasPermission } = useDashboardPermissions()

  if (!hasPermission(permission)) {
    return null
  }

  return children
}
